import React, {useState} from "react";
import {useHistory} from 'react-router-dom';
import PropTypes from "prop-types";
import classNames from "classnames";
import {Navbar, Col, Alert } from "shards-react";
import {useAuth} from '../../../contexts/AuthContext';

const MainNavbar = ({ layout, stickyTop }) => {
  
  const [error, setError] = useState('');
  const {currentUser, logout} = useAuth();
  const history = useHistory();

  async function handleLogout(){
    setError('')
    try{
      await logout()
      history.push('/login')
    }catch{
      setError('Failed to logout')
    } 
  }

  const classes = classNames(
    "main-navbar",
    "bg-white",
    stickyTop && "sticky-top"
  );
  return (
    <div className={classes}>

        <Navbar type="light" className="align-items-space-between sflex-md-nowrap p-0">
          <Col className="brandWrapper" sm="12" md="4" lg="3"> 
            <div className="companyBranding"> 
              {currentUser && (<img className="p-1" alt="brand-logo" src={ currentUser.displayLogo.url}/>)}
            </div>
          </Col>
          <Col sm="12" md="4" lg="8">
             {error && <Alert variant="danger">{error}</Alert>}
          </Col>
          <Col sm="12" md="4" lg="1" className="LogoutButton-wrapper"> 
              <button type="button" class="btn btn-danger" onClick={handleLogout}>Logout</button>
            </Col>
        </Navbar>
    </div>
  );
};

MainNavbar.propTypes = {
  /**
   * The layout type where the MainNavbar is used.
   */
  layout: PropTypes.string,
  /**
   * Whether the main navbar is sticky to the top, or not.
   */
  stickyTop: PropTypes.bool
};

MainNavbar.defaultProps = {
  stickyTop: true
};

export default MainNavbar;
